// import React, { useState } from 'react';
import React from 'react';
// import './guideFloating.scss';

const GuideFloating = () => {
  const findScrollTarget = (triggerElement) => {
    let current = triggerElement?.parentElement;

    while (current) {
      const style = window.getComputedStyle(current);
      const isScrollable =
        /(auto|scroll)/.test(style.overflowY) &&
        current.scrollHeight > current.clientHeight;

      if (isScrollable) {
        return current;
      }

      current = current.parentElement;
    }

    return document.querySelector('.mn-wrp') || document.scrollingElement || document.documentElement;
  };

  const scrollPage = (position, triggerElement) => {
    const scrollTarget = findScrollTarget(triggerElement);
    const targetTop =
      position === 'top'
        ? 0
        : scrollTarget.scrollHeight - scrollTarget.clientHeight;

    if (
      scrollTarget === document.scrollingElement ||
      scrollTarget === document.documentElement ||
      scrollTarget === document.body
    ) {
      window.scrollTo({ top: Math.max(targetTop, 0), behavior: 'smooth' });
      return;
    }

    scrollTarget.scrollTo({ top: Math.max(targetTop, 0), behavior: 'smooth' });
  };

  const handleScrollToTop = (event) => {
    scrollPage('top', event.currentTarget);
  };

  const handleScrollToBottom = (event) => {
    scrollPage('bottom', event.currentTarget);
  };

  return (
    <div className={`right-quick-wrap`}>
      <div className="right-quick-inner">
        <button 
          className="unset icon-circle fill black"
          onClick={handleScrollToTop}
        >
          <img 
            src={require('../../../assets/icons/down.png')}
            alt="상단으로" 
            className="float-icon ts rotate"
          />
        </button>
        
        <button 
          className="unset icon-circle fill black"
          onClick={handleScrollToBottom}
        >
          <img 
            src={require('../../../assets/icons/down.png')}
            alt="하단으로"
            className="float-icon ts "
          />
        </button>
      </div>
    </div>
  );
};

export default GuideFloating;
